// extracted by mini-css-extract-plugin
export default {"hideLogoDivider":"VisualizerHeader_hideLogoDivider__IRGnL","hidden":"VisualizerHeader_hidden__Y+C58"};